<div [formGroup]="form" class="u-m-top--sm">
	<ng-container formArrayName="items">
		@for (control of itemsForm.controls; track control.value.fid) {
			<div [formGroupName]="$index" class="u-row u-row--sm">
				<tvcore-input [label]="descriptionLabel() + ' *'" [showErrors]="showErrors" class="u-col-md-4" name="description" type="text">
					<tvcore-form-control-error name="required">Dit is verplicht.</tvcore-form-control-error>
				</tvcore-input>

				<tvcore-datepicker [maxYear]="maxEnd.getFullYear()" [showErrors]="showErrors" class="u-col-md-3" label="Startdatum"
													 name="startDate">
					<tvcore-form-control-error name="required">Startdatum is verplicht.</tvcore-form-control-error>
					<tvcore-form-control-error name="dateStart">
						<ng-container [ngTemplateOutlet]="datePeriod"></ng-container>
					</tvcore-form-control-error>
					<tvcore-form-control-error name="dateEnd">
						<ng-container [ngTemplateOutlet]="datePeriod"></ng-container>
					</tvcore-form-control-error>
				</tvcore-datepicker>

				<tvcore-datepicker [maxYear]="maxEnd.getFullYear()" [showErrors]="showErrors" class="u-col-md-3" label="Einddatum" name="endDate">
					<tvcore-form-control-error name="required">Einddatum is verplicht.</tvcore-form-control-error>
					<tvcore-form-control-error name="after">Einddatum kan niet voor van-datum zijn.</tvcore-form-control-error>
					<tvcore-form-control-error name="dateStart">
						<ng-container [ngTemplateOutlet]="datePeriod"></ng-container>
					</tvcore-form-control-error>
					<tvcore-form-control-error name="dateEnd">
						<ng-container [ngTemplateOutlet]="datePeriod"></ng-container>
					</tvcore-form-control-error>
				</tvcore-datepicker>

				<ng-template #datePeriod>
					Datum moet plaatsvinden in de periode vanaf {{ minStart.toUTCString() }} tot en met {{ maxEnd.toUTCString() }}
				</ng-template>

				<div class="u-col-md-1">
					@if (itemsForm.controls.length > 1) {
						<button (click)="removeLine($index)" class="c-btn-round">
							<span class="icon-trash"></span>
						</button>
					}
				</div>
			</div>
		}
	</ng-container>

	<button (click)="addLine()" class="u-m-top--sm c-btn c-btn--sm c-btn--secundary">+ stap toevoegen</button>
</div>

